import { useRef } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import { DepthOfField } from '@react-three/postprocessing'
import useCameraStore from './store'
import { easing } from 'maath'
import * as THREE from 'three'

export function DynamicDOF() {
  const { camera } = useThree()
  const getDOFSettings = useCameraStore((state) => state.getDOFSettings)

  // Initialize with default settings
  const defaultSettings = getDOFSettings()

  // Single ref for all DOF properties
  const dofRef = useRef({
    target: new THREE.Vector3(...defaultSettings.target),
    focalLength: defaultSettings.focalLength,
    bokehScale: defaultSettings.bokehScale,
    height: defaultSettings.height
  })

  // Update DOF settings smoothly
  useFrame((state, delta) => {
    const targetSettings = getDOFSettings()

    // Smooth transitions using easing
    const targetVec = new THREE.Vector3(...targetSettings.target)
    dofRef.current.target.lerp(targetVec, 0.1)

    easing.damp(dofRef.current, 'focalLength', targetSettings.focalLength, 0.25, delta)
    easing.damp(dofRef.current, 'bokehScale', targetSettings.bokehScale, 0.25, delta)
    easing.damp(dofRef.current, 'height', targetSettings.height, 0.25, delta)
  })

  return (
    <DepthOfField
      target={dofRef.current.target}
      focalLength={dofRef.current.focalLength}
      bokehScale={dofRef.current.bokehScale}
      height={dofRef.current.height}
    />
  )
}